module.exports = "<app-top-nav></app-top-nav>\n<router-outlet></router-outlet>\n<app-footer-nav></app-footer-nav>\n"